export default __webpack_public_path__ + "static/NGSwv5HMAFg6IuGlBNMjxLsE8ahuQ2e8Smg-8dd849a2ffcb2650202bdd9f831a1287.woff2";